import React, { useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert, Nav } from 'react-bootstrap';
import Filter from './components/filter/filter';
import Content from './components/report-container/report-container';
import AuditConfirmation from './components/audit-confirmation-container/audit-confirmation-container';
import ReportsService from '../../../../services/reports-service';
import { IdentityContext } from '../../../../context/identity-context';
import './issuer-reports-module.scss';

const IssuerReportsModule = () => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [items, setItems] = useState([]);
    const [auditConfirmationReports, setAuditConfirmationReports] = useState([]);
    const [filter, setFilter] = useState('All');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('individual'); // Default to Individual Securities

    const { user, role } = useContext(IdentityContext);
    const reportsService = new ReportsService();

    useEffect(() => {
        const fetchReports = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await reportsService.getReports(
                    role.toLowerCase(),
                    user?.attributes?.['custom:entity_id']
                );
                setItems(response.items);
                setAuditConfirmationReports(response.consolidated_reports);
            } catch (err) {
                setError(
                    err.response?.status
                        ? `Failed to load reports. Status: ${err.response.status}`
                        : 'Failed to load reports.'
                );
            } finally {
                setLoading(false);
            }
        };

        fetchReports();
    }, [role, user]);

    const handleItemClick = (item) => setSelectedItem(item);
    const handleFilterChange = (status) => setFilter(status);

    return (
        <Container fluid className='issuer-reports-module-container'>
            <Row className="mb-3">
                <Col className="d-flex justify-content-end">
                    <Nav variant="tabs" activeKey={activeTab} onSelect={(selectedTab) => setActiveTab(selectedTab)}>
                        <Nav.Item>
                            <Nav.Link eventKey="individual">Individual Securities</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="consolidated">Consolidated Reports</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
            </Row>
            <Row>
                {activeTab === 'individual' && (
                    <Col md={3} className="panel">
                        <Filter
                            items={items}
                            filter={filter}
                            onFilterChange={handleFilterChange}
                            onItemClick={handleItemClick}
                            selectedItem={selectedItem}
                        />
                    </Col>
                )}
                <Col md={activeTab === 'individual' ? 9 : 12}>
                    {loading && <Spinner animation="border" />}
                    {error && <Alert variant="danger">{error}</Alert>}
                    {!loading && !error && (
                        activeTab === 'individual'
                            ? <Content selectedItem={selectedItem} />
                            : <AuditConfirmation auditConfirmationReportsResponse={auditConfirmationReports} />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default IssuerReportsModule;